/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Generate_Catalog_PdfInputs */

const cs_action_generate_catalog_pdf = /** @type {(inputs: Action_Generate_Catalog_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vygenerovat PDF katalog`)
};

const en_action_generate_catalog_pdf = /** @type {(inputs: Action_Generate_Catalog_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate catalog PDF`)
};

/**
* | output |
* | --- |
* | "Generate catalog PDF" |
*
* @param {Action_Generate_Catalog_PdfInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_generate_catalog_pdf = /** @type {((inputs?: Action_Generate_Catalog_PdfInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Generate_Catalog_PdfInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_generate_catalog_pdf(inputs)
	return cs_action_generate_catalog_pdf(inputs)
});